import * as React from 'react'

import Modal from '@components/VideoScriptGenerator/Modal'
import FaqContent from './FaqContent'

interface IFaqProps {
  isOpen: boolean;
  handleOnClose: any;
}

const Faq: React.FunctionComponent<IFaqProps> = ({ isOpen, handleOnClose }) => {
  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => handleOnClose(false)}
        title="FAQ"
        description="We get t video is hard but were there for you, please claim this We’re actually built for sales folks so give us a whirl."
        modalCss={{
          overflow: 'hidden',
          maxWidth: '684px',
          padding: '26px 26px 0',
          height: '710px'
        }}
      >
        <FaqContent />
      </Modal>
      <FaqContent hidden />
    </>
  )
}

export default Faq
